/* eslint-disable no-undef */

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  //Charting Elements
  let chartClicks = 0;
  let startPoint = document.getElementById('startPoint');
  let endPoint = document.getElementById('endPoint');
  let finalStartPoint = document.getElementById('finalStartPoint');
  let finalEndPoint = document.getElementById('finalEndPoint');
  let finalPoint = document.getElementById('finalPoint');
  let startChartLine = document.getElementById('startChartLine');
  let finalChartLine = document.getElementById('finalChartLine');
  let chartingSessionComplete = false;
  const chartResetButton = document.getElementById('chartReset');
  const finalChartResetButton = document.getElementById('finalChartReset');
  const overlayButton = document.querySelector('[data-name="overlay-button"]');
  chartResetButton.style.display = 'none'; // initially don't display reset button
  finalChartResetButton.style.display = 'none'; // initially don't display reset button
  let playlistFinished = false;
  let labelsVisible = true;
  var selectedPlaylist = null;
  var endStateCategory = null;
  var calm_meta = {
    start: {
      val: null,
      aro: null,
      quad: null,
    },
    end: {
      val: null,
      aro: null,
      quad: null,
    },
    final: {
      val: null,
      aro: null,
      quad: null,
    },
    stimuli: {
      endstate: null, //calm
      category: null, //classical
      type: null, // abilene
      name: null, //playlist name (abilene 15 min)
      files: null, //playlist files
    },
    sessionType: null,
  };

  const chartingWrappers = document.querySelectorAll('.charting_plus-grid');

  chartingWrappers.forEach((chartWrapper) => {
    for (let i = 0; i < 19; i++) {
      for (let j = 0; j < 19; j++) {
        // Create the grid item container
        const gridItem = document.createElement('div');

        let quad;

        if (i >= 10 && j < 10) {
          quad = '3'; // Bottom-left quad
        } else if (i >= 10 && j >= 10) {
          quad = '4'; // Bottom-right quad
        } else if (i < 10 && j < 10) {
          quad = '1'; // Top-left quad
        } else if (i < 10 && j >= 10) {
          quad = '2'; // Top-right quad
        }

        // Set the quadrant attribute
        // gridItem.setAttribute("quadrant", quadrant);
        const val = j + 1; // Column number
        const aro = 19 - i; // Row number

        // If it's the very center div (intersection of the center row and center column)
        if (i === 9 && j === 9) {
          gridItem.setAttribute('val', val);
          gridItem.setAttribute('aro', aro);

          gridItem.classList.add('charting_plus-grid-split', 'is-center');

          const gridItemTopLeft = document.createElement('div');
          const gridItemTopRight = document.createElement('div');
          const gridItemBottomLeft = document.createElement('div');
          const gridItemBottomRight = document.createElement('div');

          gridItemTopLeft.setAttribute('val', val);
          gridItemTopLeft.setAttribute('aro', aro);
          gridItemTopLeft.setAttribute('quad', '1');

          gridItemTopRight.setAttribute('val', val);
          gridItemTopRight.setAttribute('aro', aro);
          gridItemTopRight.setAttribute('quad', '2');

          gridItemBottomLeft.setAttribute('val', val);
          gridItemBottomLeft.setAttribute('aro', aro);
          gridItemBottomLeft.setAttribute('quad', '3');

          gridItemBottomRight.setAttribute('val', val);
          gridItemBottomRight.setAttribute('aro', aro);
          gridItemBottomRight.setAttribute('quad', '4');

          gridItemTopLeft.classList.add('charting_plus-grid-item');
          gridItemTopRight.classList.add('charting_plus-grid-item');
          gridItemBottomLeft.classList.add('charting_plus-grid-item');
          gridItemBottomRight.classList.add('charting_plus-grid-item');

          gridItem.appendChild(gridItemTopLeft);
          gridItem.appendChild(gridItemTopRight);
          gridItem.appendChild(gridItemBottomLeft);
          gridItem.appendChild(gridItemBottomRight);

          // gridItem.appendChild(gridContainer);

          chartWrapper.appendChild(gridItem);
        } else if (i === 9) {
          // If it's on the center row (X-axis), split the div into top and bottom
          gridItem.classList.add('charting_plus-grid-split', 'is-horzontal');

          const gridItemTop = document.createElement('div');
          const gridItemBottom = document.createElement('div');

          gridItemTop.classList.add('charting_plus-grid-item');
          gridItemBottom.classList.add('charting_plus-grid-item');

          gridItemTop.setAttribute('val', val);
          gridItemTop.setAttribute('aro', aro);

          gridItemBottom.setAttribute('val', val);
          gridItemBottom.setAttribute('aro', aro);

          if (j < 10) {
            gridItemTop.setAttribute('quad', '1');
            gridItemBottom.setAttribute('quad', '3');
          }

          if (j >= 10) {
            gridItemTop.setAttribute('quad', '2');
            gridItemBottom.setAttribute('quad', '4');
          }

          gridItem.appendChild(gridItemTop);
          gridItem.appendChild(gridItemBottom);

          chartWrapper.appendChild(gridItem);
        } else if (j === 9) {
          // If it's on the center column (Y-axis), split the div into left and right
          gridItem.classList.add('charting_plus-grid-split');

          const gridItemLeft = document.createElement('div');
          const gridItemRight = document.createElement('div');

          gridItemLeft.classList.add('charting_plus-grid-item');
          gridItemRight.classList.add('charting_plus-grid-item');

          gridItemLeft.setAttribute('val', val);
          gridItemLeft.setAttribute('aro', aro);

          gridItemRight.setAttribute('val', val);
          gridItemRight.setAttribute('aro', aro);

          if (i < 10) {
            gridItemLeft.setAttribute('quad', '1');
            gridItemRight.setAttribute('quad', '2');
          }

          if (i >= 10) {
            gridItemLeft.setAttribute('quad', '3');
            gridItemRight.setAttribute('quad', '4');
          }

          gridItem.appendChild(gridItemLeft);
          gridItem.appendChild(gridItemRight);

          // gridItem.appendChild(gridContainer);

          chartWrapper.appendChild(gridItem);
        } else {
          // Normal grid item (not on the center row/column)
          gridItem.classList.add('charting_plus-grid-item');
          gridItem.setAttribute('quad', quad);
          gridItem.setAttribute('val', val);
          gridItem.setAttribute('aro', aro);

          chartWrapper.appendChild(gridItem);
        }
      }
    }
  });

  //Charting Functions

  const enableGrids = () => {
    document.querySelectorAll("[quad='1']").forEach((element) => {
      element.style.pointerEvents = 'auto';
    });
    document.querySelectorAll("[quad='3']").forEach((element) => {
      element.style.pointerEvents = 'auto';
    });
  };

  const disableGrids = () => {
    document.querySelectorAll("[quad='1']").forEach((element) => {
      element.style.pointerEvents = 'none';
    });

    document.querySelectorAll("[quad='3']").forEach((element) => {
      element.style.pointerEvents = 'none';
    });
  };

  const resetStartGrid = () => {
    chartClicks = 0;
    startChartLine.innerHTML = '';
    chartResetButton.style.display = 'none';
    startPoint.style.display = 'none';
    endPoint.style.display = 'none';
    labelsVisible = true;
    document.querySelectorAll("[quad='1']").forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });
    document.querySelectorAll("[quad='3']").forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });
    disableContinueButton();
  };

  const resetEndGrid = () => {
    chartClicks = 2;
    chartResetButton.style.display = 'none';
    finalPoint.style.display = 'none';
    finalChartResetButton.style.display = 'none';
    labelsVisible = true;
    disableContinueButton();
  };

  const drawLine = (startPoint, endPoint, chartLine) => {
    chartLine.innerHTML = '';
    let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', startPoint.style.left);
    line.setAttribute('y1', startPoint.style.top);
    line.setAttribute('x2', endPoint.style.left);
    line.setAttribute('y2', endPoint.style.top);
    line.setAttribute('stroke', '#E7E1D1');
    line.setAttribute('stroke-width', '2');
    chartLine.appendChild(line);
  };

  // const findMatchingParent = (chartingData, chartingMap) => {
  //   const { val, aro, quad } = chartingData.end;
  //   for (const parent in chartingMap) {
  //     const { matches } = chartingMap[parent];
  //     for (const match of matches) {
  //       if (match[0] === val && match[1] === aro && match[2] === quad) {
  //         return parent;
  //       }
  //     }
  //   }
  // };

  // general functionality

  const gridPoints = document.querySelectorAll('.charting_plus-grid-item');
  gridPoints.forEach((gridPoint) => {
    gridPoint.addEventListener('click', async function (event) {
      if (chartClicks !== 3) {
        chartClicks += 1;
      }
      let parentRect;
      if (event.currentTarget.parentElement.classList[0] === 'charting_plus-grid-split') {
        parentRect = event.currentTarget.parentElement.parentElement.getBoundingClientRect();
      } else {
        parentRect = event.currentTarget.parentElement.getBoundingClientRect();
      }
      let x = event.clientX - parentRect.left;
      let y = event.clientY - parentRect.top;
      if (chartClicks === 1) {
        disableContinueButton();
        startPoint.style.display = 'block';
        startPoint.style.left = x + 'px';
        startPoint.style.top = y + 'px';
        startPoint.style.zIndex = '2';
        calm_meta.start.val = gridPoint.getAttribute('val');
        calm_meta.start.aro = gridPoint.getAttribute('aro');
        calm_meta.start.quad = gridPoint.getAttribute('quad');
        console.log('meta data', calm_meta);
        chartResetButton.style.display = 'block';
        disableGrids();
      }
      if (chartClicks === 2) {
        chartingSessionComplete = true;
        // add end point
        endPoint.style.display = 'block';
        endPoint.style.left = x + 'px';
        endPoint.style.top = y + 'px';
        endPoint.style.zIndex = '2';
        endPoint.classList.add('is-selected');

        calm_meta.end.val = gridPoint.getAttribute('val');
        calm_meta.end.aro = gridPoint.getAttribute('aro');
        calm_meta.end.quad = gridPoint.getAttribute('quad');

        // draw start chart line and enable button
        drawLine(startPoint, endPoint, startChartLine);
        enableContinueButton();

        // final start point styling
        finalStartPoint.style.left = startPoint.style.left;
        finalStartPoint.style.top = startPoint.style.top;
        finalStartPoint.style.zIndex = startPoint.style.zIndex;
        finalStartPoint.style.display = 'block';
        finalStartPoint.style.opacity = '0.40';

        // final end point styling
        finalEndPoint.style.left = endPoint.style.left;
        finalEndPoint.style.top = endPoint.style.top;
        finalEndPoint.style.zIndex = endPoint.style.zIndex;
        finalEndPoint.style.display = 'block';
        finalEndPoint.style.opacity = '0.40';
        finalChartLine.style.opacity = '0.50';

        // draw final chart line
        drawLine(finalStartPoint, finalEndPoint, finalChartLine);
        enableGrids();
      }
      if (chartingSessionComplete && playlistFinished && chartClicks === 3) {
        finalPoint.style.display = 'block';
        finalPoint.style.left = x + 'px';
        finalPoint.style.top = y + 'px';
        finalPoint.style.zIndex = '2';
        calm_meta.final.val = gridPoint.getAttribute('val');
        calm_meta.final.aro = gridPoint.getAttribute('aro');
        calm_meta.final.quad = gridPoint.getAttribute('quad');
        finalChartResetButton.style.display = 'block';
        enableContinueButton();
      }
    });
  });

  const handleChartingLabels = () => {
    if (labelsVisible) {
      document.querySelector('[data-name="charting-high-energy"]').style.display = 'none';
      document.querySelector('[data-name="charting-low-energy"]').style.display = 'none';
      document.querySelector('[data-name="charting-pleasant"]').style.display = 'none';
      document.querySelector('[data-name="charting-unpleasant"]').style.display = 'none';
      labelsVisible = false;
    } else {
      document.querySelector('[data-name="charting-high-energy"]').style.display = 'block';
      document.querySelector('[data-name="charting-low-energy"]').style.display = 'block';
      document.querySelector('[data-name="charting-pleasant"]').style.display = 'block';
      document.querySelector('[data-name="charting-unpleasant"]').style.display = 'block';
      labelsVisible = true;
    }
  };

  overlayButton.addEventListener('click', async () => {
    handleChartingLabels();
  });

  chartResetButton.addEventListener('click', async () => {
    resetStartGrid();
  });

  finalChartResetButton.addEventListener('click', async () => {
    resetEndGrid();
  });

  const previewAudioPlayer = document.querySelector('[data-name="preview_audio_player"]');
  const previewVideoPlayer = document.querySelector('[data-name="preview_video"]');
  const previewVideoModal = document.querySelector('[data-name="video_modal_wrapper"]');
  const modalCloseButton = document.querySelector('[data-name="modal_close_button"]');
  modalCloseButton.addEventListener('click', () => {
    closeVideoPreviewModal();
  });
  const sectionContent = document.querySelector('.section_content');
  const sectionHeader = document.querySelector('.section_header');
  const sectionFooter = document.querySelector('.section_footer');

  previewAudioPlayer.style.display = 'none';

  // playlist functionality
  const user = await Wized.requests.waitFor('get_user');
  console.log('user', user);
  const userAdmin = user.data.is_admin;

  const playlistCategories = user.data.study_group.media.calm[0].category_items;
  let selectedFiles = null;
  let currentPreviewMedia = null;
  let currentPreviewButton = null;

  // div where all playlist categories go
  const playlistsContainer = document.querySelector('[data-name="playlist-categories-component"]');

  // get the templates and clone them
  const playlistCategoryTemplate = document.getElementsByTagName('template')[0];
  const playlistItemTemplate = document.getElementsByTagName('template')[1];

  const handleAudioPreviewMedia = (playlist, button) => {
    let id = button.getAttribute('playlist-id');
    let currentId = currentPreviewButton?.getAttribute('playlist-id') ?? null;
    if (currentPreviewMedia && id !== currentId) {
      previewAudioPlayer.pause();
      previewAudioPlayer.currentTime = 0;
      currentPreviewButton.textContent = 'Preview';
    }

    if (currentPreviewMedia && id === currentId) {
      if (previewAudioPlayer.paused) {
        previewAudioPlayer.play();
        button.textContent = 'Stop';
      } else if (!previewAudioPlayer.paused) {
        previewAudioPlayer.pause();
        button.textContent = 'Preview';
      }
    } else {
      [currentPreviewMedia] = playlist.files;
      previewAudioPlayer.src = currentPreviewMedia.preview_url;
      previewAudioPlayer.play();
      currentPreviewButton = button;
      button.textContent = 'Stop';
    }
  };

  const closeVideoPreviewModal = () => {
    previewVideoModal.style.display = 'none';
    sectionContent.style.overflow = 'scroll';
    previewVideoPlayer.src = '';
    if (sectionFooter) sectionFooter.style.zIndex = '2';
    if (sectionHeader) sectionHeader.style.zIndex = '2';
  };

  const openVideoPreviewModal = (videoTitle) => {
    previewVideoModal.style.display = 'block';
    sectionContent.style.overflow = 'hidden'; // Disable overflow

    document.querySelector('[data-name="video_preview_title"]').textContent = videoTitle;
    if (sectionHeader) sectionHeader.style.zIndex = '0';
    if (sectionFooter) sectionFooter.style.zIndex = '0';
  };

  const handleVideoPreviewMedia = (playlist, button) => {
    let videoTitle = playlist.files[0].title;
    [currentPreviewMedia] = playlist.files;
    previewVideoPlayer.src = currentPreviewMedia.preview_url;
    openVideoPreviewModal(videoTitle);
    previewVideoPlayer.play();
    currentPreviewButton = button;
  };

  const audioPlayer = document.querySelector('[data-name="session_audio_player"]');
  const videoPlayer = document.querySelector('[data-name="session_video"]');
  if (userAdmin) {
    new Plyr('[data-name="session_video"]');
  } else {
    new Plyr('[data-name="session_video"]', {
      controls: ['play', 'fullscreen'],
    });
  }

  const playCurrentFile = (currentPlaylistFiles) => {
    if (currentIndex >= currentPlaylistFiles.length) {
      return;
    }
    const file = currentPlaylistFiles[currentIndex];
    document.querySelector('[data-name="session_audio_title"]').textContent = file.title;
    document.querySelector('[data-name="session_audio_artist"]').textContent = file.artist;
    if (file.type === 'mixed') {
      audioPlayer.src = file.audio_url;
      videoPlayer.src = file.video_url;
      audioPlayer.style.display = 'none';
      videoPlayer.style.display = 'block';

      loadMedia(currentIndex, audioPlayer);
      loadMedia(currentIndex, videoPlayer);

      videoPlayer.onplay = () => {
        if (audioPlayer.paused) {
          audioPlayer.play();
        }
      };

      videoPlayer.onpause = () => {
        if (!audioPlayer.paused) {
          audioPlayer.pause();
        }
      };

      videoPlayer.onvolumechange = () => {
        audioPlayer.volume = videoPlayer.volume;
      };

      videoPlayer.ontimeupdate = () => {
        if (Math.abs(videoPlayer.currentTime - audioPlayer.currentTime) > 0.1) {
          audioPlayer.currentTime = videoPlayer.currentTime;
        }
      };
      videoPlayer.onended = () => playNextFile(currentPlaylistFiles);
    } else if (file.type === 'audio') {
      audioPlayer.src = file.audio_url;
      audioPlayer.style.display = 'block';
      videoPlayer.style.display = 'none';
      loadMedia(currentIndex, audioPlayer);

      audioPlayer.onended = () => playNextFile(currentPlaylistFiles);
    } else if (file.type === 'video') {
      videoPlayer.src = file.video_url;
      videoPlayer.style.display = 'block';
      audioPlayer.style.display = 'none';

      loadMedia(currentIndex, videoPlayer);
      videoPlayer.onended = () => playNextFile(currentPlaylistFiles);
    }
  };

  let currentIndex = 0;

  const loadPlaylist = (files) => {
    const currentPlaylist = files;
    currentIndex = 0;
    playCurrentFile(currentPlaylist);
  };

  const createPlaylistItems = (playlistCategoryContainer, playlistCategories, category) => {
    const playlists = playlistCategories
      .map((category) => {
        return category.playlist;
      })
      .flat(Infinity);
    console.log('playlists', playlists);
    playlists.forEach((playlist) => {
      const playlistItem = playlistItemTemplate.content.cloneNode(true);
      console.log('playlistItem', playlistItem);
      playlistItem
        .querySelector('[data-name="whole_playlist_item"]')
        .setAttribute('playlist-id', playlist.id);
      if (playlist.files.length > 0) {
        if (playlist.playlist_type === 'visual') {
          if (playlist.files.length === 1) {
            playlistItem
              .querySelector('[data-name="thumbnail-image-container"]')
              .classList.add('is-single');
          }
          playlistItem
            .querySelector('[data-name="thumbnail-image-container"]')
            .classList.add('is-visual');
          if (!playlist.guidance) {
            playlistItem.querySelector('[data-name="guidance"]').classList.add('hide');
          }
        }
        playlistItem.querySelector('[data-name="playlist-thumbnail-image"]').src =
          playlist.playlist_thumbnail.url;
        playlistItem.querySelector('[data-name="playlist-title"]').textContent =
          playlist.playlist_name;
        playlistItem
          .querySelector('[data-name="playlist-thumbnail-image"]')
          .setAttribute('playlist-id', playlist.id);
        playlistItem
          .querySelector('[data-name="playlist-thumbnail-image"]')
          .addEventListener('click', function () {
            const parentContainer = this.closest('.thumbnail_component');
            let playlistId = parentContainer.getAttribute('playlist-id');
            if (playlist.id === playlistId) {
              selectedFiles = playlist.files;
            }
            selectedPlaylist = playlist;
            endStateCategory = category;
            loadPlaylist(selectedFiles);
          });
        const previewButton = playlistItem.querySelector('[data-name="preview_stimuli"]');
        previewButton.setAttribute('playlist-id', playlist.id);
        previewButton.addEventListener('click', function () {
          if (playlist.files[0].type === 'audio') {
            handleAudioPreviewMedia(playlist, this);
          } else {
            handleVideoPreviewMedia(playlist, this);
          }
        });
        playlistCategoryContainer.appendChild(playlistItem);
      }
    });
  };

  const renderPlaylistCategories = () => {
    console.log('playlistCategories', playlistCategories);
    playlistCategories.forEach((category) => {
      const playlistCategory = playlistCategoryTemplate.content.cloneNode(true);
      const playlistContainer = playlistCategory.querySelector('[data-name="playlist_container"]');
      playlistCategory.querySelector('[data-name="playlist_type"]').textContent =
        category.category_item_name;
      playlistCategory.querySelector('[data-name="playlist_info"]').textContent =
        category.category_item_info;
      createPlaylistItems(
        playlistContainer,
        category.playlist_categories,
        category.category_item_info
      );
      playlistsContainer.appendChild(playlistCategory);
      // Initiate newly created swiper structure
      new Swiper(playlistContainer, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        cssMode: true,
        createElements: true,
        navigation: false,
        pagination: {
          enabled: true,
          clickable: true,
          dynamicBullets: true,
        },
      });
    });
  };
  renderPlaylistCategories();

  const playlistPlayer = document.querySelector('[data-name="calm_playlist"]');

  const playNextFile = (currentPlaylist) => {
    currentIndex++;
    if (currentIndex < currentPlaylist.length) {
      playCurrentFile(currentPlaylist);
    } else if (!playlistFinished) {
      playlistFinished = true;
      playlistPlayer.classList.add('is-selected');
      enableContinueButton();
      advancePage();
    }
  };

  const loadMedia = (index, player) => {
    if (index === 0) {
      player.load();
    } else {
      player.play();
    }
  };
  document.addEventListener('completed-page', async function () {
    Wized.data.v.session_metadata = calm_meta;
    await Wized.requests.execute('complete_session');
  });

  const sessionPath = Wized.data.n.path;
  const dailyPractice = '/calm/sessions/001';
  const acutePractice = '/calm/sessions/002';

  // logic specific to daily practice
  if (sessionPath === dailyPractice) {
    const startSessionButton = document.querySelector('[data-name="calm_confirm_session"]');

    // start media on session ready click
    startSessionButton.addEventListener('click', async () => {
      if (audioPlayer.style.display !== 'none') {
        audioPlayer.play();
      }
      if (videoPlayer.style.display !== 'none') {
        videoPlayer.play();
      }
      calm_meta = {
        ...calm_meta,
        sessionType: 'Daily Practice',
        stimuli: {
          endstate: 'calm',
          category: endStateCategory,
          files: selectedPlaylist.files,
          type: selectedPlaylist.playlist_type,
          name: selectedPlaylist.playlist_name,
        },
      };
    });

    // listen for "ready" event
    document.addEventListener('ready', async function () {
      previewAudioPlayer.src = '';
    });
  }

  // logic specific to Acute Practice
  if (sessionPath === acutePractice) {
    // handle starting the session
    function handleStartSession() {
      if (audioPlayer.style.display !== 'none') {
        audioPlayer.play();
      }
      if (videoPlayer.style.display !== 'none') {
        videoPlayer.play();
      }
      calm_meta = {
        ...calm_meta,
        sessionType: 'Acute Episode',
        stimuli: {
          endstate: 'calm',
          category: endStateCategory,
          files: selectedPlaylist.files,
          type: selectedPlaylist.playlist_type,
          name: selectedPlaylist.playlist_name,
        },
      };
    }
    // change the continue button text to Start Session
    document.addEventListener('experience-selection', async function () {
      backButton.style.opacity = '0';
      backButton.style.pointerEvents = 'none';
      continueButton.textContent = 'Start Session';
      continueButton.addEventListener('click', handleStartSession, true);
    });
    // change the start session button back to a continue button
    document.addEventListener('experience-page', async function () {
      const continueButton = document.querySelector('#continueBtn');
      continueButton.textContent = 'Continue';
      continueButton.removeEventListener('click', handleStartSession, true);
    });
  }
});
